import { render, staticRenderFns } from "./NewOptionForm.vue?vue&type=template&id=2e2edca5"
import script from "./NewOptionForm.vue?vue&type=script&lang=js"
export * from "./NewOptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports